export const COMMENTS_PANEL = 'commentsPanel';
